export default {
  data () {
    return {
      showAllQuestions: false
    }
  }
}
